import { render, staticRenderFns } from "./items.form.vue?vue&type=template&id=b22554e0&scoped=true&"
import script from "./items.form.vue?vue&type=script&lang=js&"
export * from "./items.form.vue?vue&type=script&lang=js&"
import style0 from "./items.form.vue?vue&type=style&index=0&id=b22554e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22554e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol})
